import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CustomerSearchField extends Component {

  constructor(props) {
    super(props);
    this.state = {
      query: '',
      showDropdown: false,
      highlightIndex: -1
    };
    this._debounceTimer = null;
    this.onInputChange = this.onInputChange.bind(this);
    this.onItemSelect = this.onItemSelect.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onInputChange(e) {
    let query = e.target.value;
    this.setState({ query, showDropdown: true, highlightIndex: -1 });

    if (this._debounceTimer) clearTimeout(this._debounceTimer);

    this._debounceTimer = setTimeout(() => {
      if (this.props.onSearch && query.length > 1) {
        this.props.onSearch(query);
      }
    }, 250);
  }

  onKeyDown(e) {
    let { customers } = this.props;
    customers = customers || [];
    let { highlightIndex, showDropdown } = this.state;

    if (!showDropdown || customers.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.setState({ highlightIndex: Math.min(highlightIndex + 1, customers.length - 1) });
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.setState({ highlightIndex: Math.max(highlightIndex - 1, 0) });
    } else if (e.key === 'Enter' && highlightIndex >= 0) {
      e.preventDefault();
      this.onItemSelect(customers[highlightIndex]);
    } else if (e.key === 'Escape') {
      this.setState({ showDropdown: false });
    }
  }

  onItemSelect(customer) {
    let name = ((customer.first_name || '') + ' ' + (customer.last_name || '')).trim();
    if (!name) name = customer.company || customer.email || '';
    this.setState({ query: name, showDropdown: false, highlightIndex: -1 });

    if (this.props.onSelect) {
      this.props.onSelect(customer);
    }
  }

  onBlur() {
    setTimeout(() => {
      this.setState({ showDropdown: false });
    }, 200);
  }

  onFocus() {
    let { customers } = this.props;
    if (customers && customers.length > 0 && this.state.query.length > 1) {
      this.setState({ showDropdown: true });
    }
  }

  render() {
    let { customers } = this.props;
    let { query, showDropdown, highlightIndex } = this.state;
    customers = customers || [];

    return (
      <div style={{ position: 'relative' }}>
        <div style={{ position: 'relative' }}>
          <i className="fa fa-search" style={{ position: 'absolute', left: '8px', top: '8px', color: '#999', fontSize: '11px' }}></i>
          <input
            type="text"
            className="form-control"
            placeholder="Search by name, email, or company..."
            value={query}
            onChange={this.onInputChange}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            onKeyDown={this.onKeyDown}
            style={{ paddingLeft: '26px' }}
          />
        </div>
        {showDropdown && customers.length > 0 && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 9999,
            background: '#fff',
            border: '1px solid #ddd',
            borderTop: 'none',
            borderRadius: '0 0 4px 4px',
            maxHeight: '240px',
            overflowY: 'auto',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
          }}>
            {customers.map((customer, idx) => {
              let name = ((customer.first_name || '') + ' ' + (customer.last_name || '')).trim();
              let company = customer.company || '';
              let email = customer.email || '';
              let isHighlighted = idx === highlightIndex;
              return (
                <div
                  key={customer.id || idx}
                  style={{
                    padding: '6px 10px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #f0f0f0',
                    background: isHighlighted ? '#f5f5f5' : '#fff'
                  }}
                  onMouseDown={() => this.onItemSelect(customer)}
                  onMouseEnter={() => this.setState({ highlightIndex: idx })}
                >
                  <div style={{ fontWeight: 500, fontSize: '12px' }}>{name || 'No Name'}{company ? ' — ' + company : ''}</div>
                  {email && <div style={{ fontSize: '11px', color: '#666' }}>{email}</div>}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

CustomerSearchField.propTypes = {
  onSearch: PropTypes.func,
  onSelect: PropTypes.func,
  customers: PropTypes.array
};

export default CustomerSearchField;



// WEBPACK FOOTER //
// app/components/drafts/CustomerSearchField.jsx